import { formatPhoneNumber } from '@mybonum/utils';
import { Button, TableColumnType, Typography } from 'antd';
import dayjs from 'dayjs';

import { TCustomerInfo } from '../components/appointments-popup';
import { TCustomerType } from '../types';

import { DEFAULT_DATE_FORMAT } from '@/constants/date-formats.ts';
import { useTableSortColumns } from '@/hooks/use-table-columns.ts';

type TUseColumnsProps = {
    onAppointmentsClick: (customer: TCustomerInfo) => void;
};

export const useColumns = ({
    onAppointmentsClick,
}: TUseColumnsProps): TableColumnType<TCustomerType>[] => {
    const sortColumns = useTableSortColumns<TCustomerType>();

    return sortColumns([
        {
            width: 70,
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            sorter: true,
        },
        {
            width: 160,
            key: 'firstName',
            title: 'First Name',
            dataIndex: 'first_name',
            sorter: true,
            render: (_, record) => {
                return record.firstName;
            },
        },
        {
            width: 160,
            key: 'lastName',
            title: 'Last Name',
            dataIndex: 'last_name',
            sorter: true,
            render: (_, record) => {
                return record.lastName;
            },
        },
        {
            width: 260,
            key: 'email',
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
            render: (_, record) => (
                <Typography.Link href={`mailto:${record.email}`}>{record.email}</Typography.Link>
            ),
        },
        {
            width: 190,
            key: 'phone',
            title: 'Phone number',
            dataIndex: 'phone',
            sorter: true,
            render: (_, record) =>
                record.phone ? (
                    <Typography.Link href={`tel:${record.phone}`}>
                        {formatPhoneNumber(record.phone)}
                    </Typography.Link>
                ) : null,
        },
        {
            width: 176,
            key: 'createdDate',
            title: 'Created Date',
            dataIndex: 'created_date',
            sorter: true,
            render: (_, record) => {
                return dayjs(record.createdDate).format(DEFAULT_DATE_FORMAT);
            },
        },
        {
            width: 116,
            key: 'patients',
            title: 'Patients',
            dataIndex: 'patient_count',
            sorter: true,
            render: (_, record) => record.patients,
        },
        {
            width: 166,
            key: 'totalSearches',
            title: 'Total Searches',
            dataIndex: 'search_count',
            sorter: true,
            render: (_, record) => record.totalSearches,
        },
        {
            width: 199,
            key: 'totalAppointments',
            title: 'Total Appointments',
            dataIndex: 'appointment_count',
            sorter: true,
            render: (_, record) => (
                <Button
                    type="link"
                    onClick={() =>
                        onAppointmentsClick({
                            id: record.id,
                            fullName: `${record.firstName} ${record.lastName}`.trim(),
                        })
                    }
                    disabled={!record.totalAppointments}
                >
                    {record.totalAppointments}
                </Button>
            ),
        },
    ]);
};
